<template>
  <div class="footer">
    <div class="top-row-footer">
      <div class="info">
        <div class="logo">
          <img src="../../assets/footer/logo-footer.png" alt="" />
          <!-- <span class="company-name">دریک</span> -->
        </div>

        <div class="about">
          <p>
            شرکت نرم افزاری دریک فعال در عرصه خدماتی همچون طراحی وبسایت، سئو و
            بهینه سازی، طراحی اپلیکیشن های موبایلی و نرم افزار های تحت با کمترین
            هزینه پوشش دهد
          </p>
        </div>

        <div class="social-icon">
          <p>ما را در شبکه های اجتماعی دنبال کنید</p>
          <div class="icons">
            <a :href="info.facebook" target="_blank">
              <img src="../../assets/sochialNetworkIcon/facebook.png" alt=""
            /></a>
            <a :href="info.instagram" target="_blank">
              <img src="../../assets/sochialNetworkIcon/instagram.png" alt=""
            /></a>
            <a :href="info.twitter" target="_blank">
              <img src="../../assets/sochialNetworkIcon/twitter.png" alt=""
            /></a>
            <a :href="info.telegram" target="_blank">
              <img src="../../assets/sochialNetworkIcon/Telegram.png" alt=""
            /></a>
            <a :href="info.whatsapp" target="_blank">
              <img src="../../assets/sochialNetworkIcon/Whatsapp.png" alt=""
            /></a>
          </div>
        </div>
      </div>
      <div class="footer-menu">
        <ul class="content-menu">
          <span class="title-menu">خدمات ما</span>
          <li
            @click="$router.push(item.src)"
            v-for="(item, index) in services"
            :key="index"
          >
            {{ item.name }}
          </li>
        </ul>

        <ul class="content-menu">
          <span class="title-menu">راهنمای سایت</span>
          <li
            @click="$router.push(item.src)"
            v-for="(item, index) in help"
            :key="index"
          >
            {{ item.name }}
          </li>
        </ul>

        <ul class="content-menu">
          <span class="title-menu">درباره ما</span>
          <li
            @click="$router.push(item.src)"
            v-for="(item, index) in aboutus"
            :key="index"
          >
            {{ item.name }}
          </li>
        </ul>

        <ul class="content-menu">
          <span class="title-menu">تماس با ما</span>
          <li>
            <div class="item-contact">
              <img src="../../assets/footer/phone.png" alt="" />
              <span>{{ info.number }}</span>
            </div>
          </li>

          <li>
            <div class="item-contact">
              <img src="../../assets/footer/email.png" alt="" />
              <span>{{ info.email }}</span>
            </div>
          </li>

          <li>
            <div class="item-contact">
              <img src="../../assets/footer/location.png" alt="" />
              <span>{{ info.address }}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="bottom-row-footer" dir="ltr">
      <div class="email-share">
        <p>
          با وارد کردن ایمیل خود، لینک دعوت جهت ثبت نام در سایت را دریافت کنید
        </p>
        <label>
          <input type="email" placeholder="ایمیل" />
          <button class="email-btn">
            <img src="../../assets/footer/right-arrow.png" alt="" />
          </button>
        </label>
      </div>
      <div class="copyright">
        <p>
          تمامی حقوق برای دریک محفوظ است و استفاده از مطالب دریک تنها با ذکر نام
          دریک و درج لینک مستقیم مجاز است
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "the-footer",
  data() {
    return {
      info: {},
      services: [
        { name: "آموزش", src: "" },
        { name: "اخبار ارز‌های دیجیتال", src: "" },
        { name: "کیف پول مشتریان", src: "" },
        { name: "انتقاد و پیشنهاد", src: "" },
        { name: "سطح های کاربری", src: "" },
      ],

      help: [
        { name: "نحوه ثبت سفارش", src: "" },
        { name: "نحوه محاسبه کارمزد", src: "" },
        { name: "پرسش های متدوال", src: "" },
        { name: "شیوه پرداخت", src: "" },
      ],

      aboutus: [
        { name: "درباره ما", src: "/about" },
        { name: "قوانین سایت", src: "/guide" },
        { name: "حریم خصوصی", src: "/qa" },
      ],
    };
  },
  methods: {
    async getInfo() {
      const res = await this.$axios.get("/exchange-info");
      this.$store.state.info = res.baseDTO;
  
      this.info = res.baseDTO || {
        address: "",
        appAndroid: "",
        appIOS: "",
        email: "",
        instagram: "",
        linkedin: "",
        number: "",
        telegram: "",
        twitter: "",
      };
    },
  },

  mounted() {
    this.getInfo();
  },
};
</script>

<style lang="scss" scoped>
.footer {
  display: flex;
  flex-direction: column;
  gap: 20px;
  background-color: rgba(11, 20, 38, 1);
  padding: 20px 50px;
  direction: rtl;

  .top-row-footer {
    display: flex;
    flex-direction: row;
    gap: 100px;
    align-items: start;
    flex-wrap: wrap;

    .info {
      flex-grow: 1;
      flex-basis: 100px;
      display: flex;
      flex-direction: column;
      gap: 25px;

      .logo {
        display: flex;
        flex-direction: row;
        gap: 13px;
        align-items: center;

        img {
          width: 30%;
          height: 30%;
        }

        .company-name {
          font-size: clamp(16px, 2vw, 18px);
          color: rgba(251, 251, 253, 1);
        }
      }

      .about {
        font-size: clamp(14px, 2vw, 16px);
        color: rgba(215, 200, 200, 1);
        text-align: right;
      }

      .social-icon {
        display: flex;
        flex-direction: column;
        align-items: start;
        gap: 14px;
        text-align: right;

        .icons {
          display: flex;
          flex-direction: row;
          gap: 36px;

          a {
            img {
              cursor: pointer;
            }
          }
        }

        p {
          font-size: clamp(14px, 2vw, 16px);
          color: rgba(251, 251, 253, 1);
        }
      }
    }

    .footer-menu {
      flex-grow: 3;
      flex-basis: 100px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: baseline;
      flex-wrap: wrap;
      gap: 20px;

      .content-menu {
        display: flex;
        flex-direction: column;
        gap: 20px;
        flex-grow: 1;
        justify-content: center;
        flex-basis: 100px;

        span {
          font-size: clamp(14px, 2vw, 16px);
          color: #1199fa;
          text-align: right;
        }

        li {
          font-size: clamp(12px, 2vw, 14px);
          color: #fbfbfd;
          list-style: none;
          text-align: right;
          cursor: pointer;

          &:hover {
            color: #fbfbfd;
          }

          .item-contact {
            display: flex;
            flex-direction: row;
            gap: 8px;
            align-items: center;

            span {
              color: rgba(251, 251, 253, 1);
              font-size: clamp(12px, 2vw, 14px);
            }
          }
        }
      }
    }
  }

  .bottom-row-footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: self-end;
    gap: 30px;
    flex-wrap: wrap;

    .copyright {
      color: rgba(215, 200, 200, 1);
      font-size: clamp(12px, 2vw, 14px);
      text-align: right;
    }

    .email-share {
      display: flex;
      flex-direction: column;
      width: 200px;
      gap: 16px;

      p {
        font-size: clamp(10px, 2vw, 12px);
        color: #fbfbfd;
        text-align: right;
      }

      label {
        border-bottom: 1px solid #8c8585;
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        input {
          color: #fbfbfd;
        }

        button {
          background-color: rgba(17, 153, 250, 1);
          border-radius: 8px 0 0 0;
          width: 23px;
          height: 25px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
